import React from 'react';
import "./index.css";
import { SiMinutemailer } from "react-icons/si";
import {FaLinkedinIn,FaGithub,FaInstagram,FaTwitter} from 'react-icons/fa';

const Contact = () => {
  return (
    <>
      <section className='contact-sec' id='contact'>
        <div className='contact-head'>
          <span>04.</span> Get In Touch
        </div>
        <div className='contact-content'>
          <div className='mail-icon'>
            <SiMinutemailer/>
          </div>
          <p>
            Although I'm currently looking for any new opportunities, 
            my inbox is always open. Whether you have a question or just want to say hi, <br/>
            feel free to shoot me a email!
          </p>
          <div className='contact-me'>
            <a rel='noreferrer' href='mailto:prince.patel1576@gmail.com' target='_blank'>Say Hello</a>
          </div>
          <div className='social-contact'>
            <p>or connect on - </p>
            <div className='social-icons'>
              <a href='https://www.linkedin.com/in/prince-patel-bb6b32194/' target='_blank' rel='noreferrer'><FaLinkedinIn className='icons'/></a>
              <a href='https://github.com/princepatel157' target='_blank' rel='noreferrer'><FaGithub className='icons'/></a>              
              <a href='https://www.instagram.com/prince.vikram.singh.patel/' target='_blank' rel='noreferrer'><FaInstagram className='icons'/></a>
              <a href='https://twitter.com/princepatel1576'target='_blank' rel='noreferrer'><FaTwitter className='icons'/></a>          
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Contact